import React from 'react';

import Router from './router';
import Navigation from './navigation';

const Layout = props => (
  <div id="layout">
    <Router />
    <Navigation {...props} />
  </div>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/layout.js